"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return SimpleLRUCache;
    }
});
let SimpleLRUCache = class SimpleLRUCache {
    async get(key, valueGetter) {
        if (this.cache[key]) {
            this.keys = this.keys.filter((k)=>k !== key);
            this.keys.push(key);
            return this.cache[key];
        } else {
            const value = await valueGetter();
            this.set(key, value);
            return value;
        }
    }
    set(key, value) {
        if (this.keys.length >= this.limit) {
            const keyToRemove = this.keys.shift();
            delete this.cache[keyToRemove];
        }
        this.cache[key] = value;
        this.keys.push(key);
    }
    delete(key) {
        if (!this.cache[key]) {
            return;
        }
        delete this.cache[key];
        this.keys = this.keys.filter((k)=>k !== key);
    }
    clear() {
        this.cache = {};
        this.keys = [];
    }
    constructor(limit = 1000){
        this.limit = limit;
        this.cache = {};
        this.keys = [];
    }
};
